import * as type from '../types/validate'

const initialState = {
    processStatus: null,
    processLoading: true,
    processError: null,
}

export const validate = (state = initialState, payload) => {
    switch(payload.type){
        case type.REQUEST_SUBSCRIPTION_ENROLMENT:
            return{
                ...state,
                processStatus: null,
                processLoading: false,
                processError: null,
            }
        case type.REVOKE_SUBSCRIPTION_ENROLMENT:
            return{
                ...state,
                processStatus: null,
                processLoading: false,
                processError: payload.message,
            }
        case type.GRANT_SUBSCRIPTION_ENROLMENT:
            return{
                ...state,
                processStatus: "success",
                processLoading: false,
                processError: null,
            }
        case type.RESET_SUBSCRIPTION_ENROLMENT:
            return{
                ...state,
                processStatus: null,
                processLoading: false,
                processError: null,
            }
        default:
            return state
    }
}